import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Sparkle, Drop, ArrowRight } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Iter24 H1 — Premium Services section on HomePage.
 * Iter26 A — Same compact height as discover cards (p-4, w-10 icon, text-sm title)
 * + rotating animated border (orange for Liquid Glass, purple for Detailing).
 */
export default function PremiumServicesSection() {
  const [settings, setSettings] = useState({ detailing_enabled: false, detailing_i_plote_enabled: false });

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/settings/public`);
        setSettings(r.data || {});
      } catch (err) { console.warn('[Premium] settings load failed', err?.response?.status || err?.message); }
    })();
  }, []);

  if (!settings.detailing_enabled && !settings.detailing_i_plote_enabled) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
                className="px-4 space-y-3" data-testid="premium-services-section">
      <p className="text-xs uppercase tracking-wider text-white/45">Shërbime Premium</p>

      {settings.detailing_enabled && (
        <Link to="/liquid-glass" data-testid="premium-liquid-glass-card"
              className="premium-glow-orange flex items-center justify-between p-4 rounded-2xl active:scale-[0.99] transition-transform">
          <div className="flex items-center gap-3 relative">
            <div className="w-10 h-10 rounded-xl bg-[#FF6B35]/20 flex items-center justify-center">
              <Sparkle size={20} weight="fill" className="text-[#FF6B35]" />
            </div>
            <div>
              <p className="text-sm font-medium text-white">Liquid Glass</p>
              <p className="text-xs text-white/45">Si nga showroom — mbrojtje deri 3 vjet</p>
            </div>
          </div>
          <ArrowRight size={20} className="text-[#FF6B35] relative" />
        </Link>
      )}

      {settings.detailing_i_plote_enabled && (
        <Link to="/detailing-i-plote" data-testid="premium-detailing-card"
              className="premium-glow-purple flex items-center justify-between p-4 rounded-2xl active:scale-[0.99] transition-transform">
          <div className="flex items-center gap-3 relative">
            <div className="w-10 h-10 rounded-xl bg-[#7C3AED]/20 flex items-center justify-center">
              <Drop size={20} weight="fill" className="text-[#7C3AED]" />
            </div>
            <div>
              <p className="text-sm font-medium text-white">Detailing i Plotë</p>
              <p className="text-xs text-white/45">Brendësi + jashtësi + motor — ceramic</p>
            </div>
          </div>
          <ArrowRight size={20} className="text-[#7C3AED] relative" />
        </Link>
      )}
    </motion.div>
  );
}
